export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20modern%20spreadsheet%20data%20management%20dashboard%20concept%20with%20abstract%20floating%20data%20charts%20tables%20and%20analytics%20visualizations%20on%20a%20warm%20light%20gradient%20background%2C%20soft%20sage%20green%20and%20cream%20color%20palette%2C%20minimalist%20SaaS%20hero%20aesthetic%2C%20clean%20professional%20corporate%20style%2C%20high%20detail%2C%20editorial%20quality&width=1680&height=840&seq=hero-itaobuy-v3&orientation=landscape')`
        }}
      >
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-32">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
            <strong>Itaobuy Spreadsheet</strong>: La Guida Italiana Completa per Gestire i Tuoi Dati in Modo Semplice e Sicuro
          </h1>
          <p className="text-base md:text-lg text-white/85 mb-8 max-w-2xl mx-auto leading-relaxed">
            Scopri come funziona <strong>Itaobuy Spreadsheet</strong>, quali sono i vantaggi principali, come utilizzarlo correttamente e perch&eacute; sempre pi&ugrave; utenti scelgono questo strumento.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-center"
            >
              Itaobuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-accent-500 text-background-50 rounded-full hover:bg-accent-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-center"
            >
              Buy It Now
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 mt-8">
            <span className="inline-flex items-center gap-1.5 text-xs md:text-sm text-white/80 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full">
              <i className="ri-check-line text-primary-400 text-sm"></i>
              Guida aggiornata
            </span>
            <span className="inline-flex items-center gap-1.5 text-xs md:text-sm text-white/80 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full">
              <i className="ri-check-line text-primary-400 text-sm"></i>
              Analisi completa
            </span>
            <span className="inline-flex items-center gap-1.5 text-xs md:text-sm text-white/80 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full">
              <i className="ri-check-line text-primary-400 text-sm"></i>
              Informazioni sulla sicurezza
            </span>
            <span className="inline-flex items-center gap-1.5 text-xs md:text-sm text-white/80 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full">
              <i className="ri-check-line text-primary-400 text-sm"></i>
              Tutorial passo dopo passo
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}